module.exports = __webpack_public_path__ + "img/point-manage.a97cf236.svg";